export enum ReportType {
    TRANSACTIONS = "Transactions",
    STATEMENT = "Statement",
    FUNDING = "Funding"
}
